/*jshint maxcomplexity: 10 */
import memberInfo from 'static/script/app/data/member-info';

let WhenLoggedIn = function () {

    this._whenLoggedIn = function (callback) {
        if (!memberInfo.isLoggedIn) {
            this.trigger(document, 'ui:login:show');
            return;
        }
        callback();
    };

};

module.exports = WhenLoggedIn;


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/when-logged-in.js